import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "react-modal";
import { saveAs } from "file-saver";
import { validateToken } from "../tokenValidation";
import secureStorage from "../utils/secureStorage";
const Profile = () => {
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [qrCode, setQrCode] = useState(null); // State to store the QR code
  const [isLoading, setIsLoading] = useState(false);
  const [abhaCard, setAbhaCard] = useState(null); // State for ABHA card data
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL;

  const aadhaarResponse =
    location.state?.aadhaarResponse ||
    JSON.parse(secureStorage.get("user")) ||
    {};

  const downloadAbhaCard = () => {
    if (abhaCard) {
      const fileName = "ABHA_Card.png";
      saveAs(abhaCard, fileName);
    }
    setIsModalOpen(false)
  };

  const fetchQrCode = async () => {
    setIsLoading(true);
    console.log("fetchQrCode function called");
    try {
      const clinicId = secureStorage.get("clinic");
      const response = await fetch(
        `${API_URL}abdm-profile/generateQrCode?abhaNumber=${aadhaarResponse?.abhaNumber}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-HIP-ID":clinicId,
            Authorization: `Bearer ${aadhaarResponse?.token}`,
          },
        }
      );

      console.log("Response received:", response);

      if (response.ok) {
        const jsonResponse = await response.json();
        if (jsonResponse.status === 200 && jsonResponse.data) {
          const qrCodeUrl = `data:image/png;base64,${jsonResponse.data}`;
          setQrCode(qrCodeUrl);
        } else {
          console.error("Failed to fetch QR Code: Invalid response", jsonResponse);
        }
      } else {
        console.error("Failed to fetch QR Code:", response.status, await response.text());
      }
    } catch (error) {
      console.error("Error fetching QR Code:", error);
    } finally {
      setIsLoading(false);
    }
  };


  const fetchAbhaCard = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `${API_URL}abdm-profile/abha-card?abhaNumber=${aadhaarResponse?.abhaNumber}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${aadhaarResponse?.token}`,
            "X-HIP-ID": secureStorage.get("clinic"),
          },
        }
      );

      if (response.ok) {
        const jsonResponse = await response.json();
        if (jsonResponse.status === 200 && jsonResponse.data) {
          setAbhaCard(`data:image/png;base64,${jsonResponse.data}`);
          setIsModalOpen(true); // Open the modal
        } else {
          console.error("ABHA card fetch failed:", jsonResponse.message);
        }
      } else {
        console.error("ABHA card fetch failed:", response.status);
      }
    } catch (error) {
      console.error("Error fetching ABHA card:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    validateToken(navigate);
  }, [navigate]);

  useEffect(() => {
    fetchQrCode();
  }, [aadhaarResponse?.abhaNumber, aadhaarResponse?.token]);



  return (
    <div className="bg-gray-100 min-h-screen flex">

      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="w-16 h-16 border-4 border-t-teal-600 border-gray-300 rounded-full animate-spin"></div>
        </div>
      )}
      {/* Sidebar */}
      <div
        className={`bg-teal-600 text-white transition-all duration-300 ease-in-out ${isSidebarOpen ? "w-64" : "w-16"
          }`}
      >
        <div className="flex items-center justify-between p-4">
          <h3
            className={`text-lg font-bold ${isSidebarOpen ? "opacity-100" : "opacity-0 hidden"
              } transition-opacity duration-300`}
          >
            My Account
          </h3>
          <button
            className="text-white text-2xl focus:outline-none"
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          >
            {isSidebarOpen ? "←" : "→"}
          </button>
        </div>
        <ul className="space-y-6 mt-10">
          <li className="flex items-center space-x-4 p-4 hover:bg-teal-500 cursor-pointer">
            {isSidebarOpen && <span>ABHA card</span>}
          </li>
          {/* <li className="flex items-center space-x-4 p-4 hover:bg-teal-500 cursor-pointer">
            {isSidebarOpen && <span>Edit profile</span>}
          </li>
          <li className="flex items-center space-x-4 p-4 hover:bg-teal-500 cursor-pointer">
            {isSidebarOpen && <span>Set password</span>}
          </li>
          <li className="flex items-center space-x-4 p-4 hover:bg-teal-500 cursor-pointer">
            {isSidebarOpen && <span>Re-KYC verification</span>}
          </li>
          <li className="flex items-center space-x-4 p-4 hover:bg-teal-500 cursor-pointer">
            {isSidebarOpen && <span>Deactivate/Delete</span>}
          </li> */}
          <li
            className="flex items-center space-x-4 p-4 hover:bg-teal-500 cursor-pointer"
            onClick={() => navigate("/ViewDocuments")}
          >
            {isSidebarOpen && <span>View Documents</span>}
          </li>
        </ul>
      </div>

      {/* Main Content */}
      <div className="flex-grow p-6">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-xl font-bold text-teal-600">
            Welcome, {aadhaarResponse?.firstName || "User"} {aadhaarResponse?.middleName || ""} {aadhaarResponse?.lastName || ""}
          </h3>
          <div className="flex space-x-4">
            <button
              onClick={fetchAbhaCard}
              className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600"
            >
              View/Download ABHA card
            </button>
            {/* <button className="px-4 py-2 bg-orange-500 text-white rounded-md text-sm hover:bg-orange-600">
              Print ABHA
            </button>
            <button className="px-4 py-2 bg-orange-500 text-white rounded-md text-sm hover:bg-orange-600">
              Print PVC
            </button> */}
          </div>
        </div>

        <div className="flex items-center bg-white shadow-md rounded-lg p-4">
          {/* Profile Picture */}
          <div className="w-24 h-24 rounded-full border-2 border-teal-600 flex items-center justify-center bg-gray-100">
            {aadhaarResponse?.profilePhoto ? (
              <img
                src={`data:image/jpeg;base64,${aadhaarResponse.profilePhoto}`}
                alt="Profile"
                className="w-full h-full rounded-full"
              />
            ) : (
              <span className="text-gray-400 text-sm">No Photo</span>
            )}
          </div>

          {/* User Information */}
          <div className="ml-6 flex-grow">
            <p className="text-gray-700 text-sm">
              <strong>Name:</strong> {aadhaarResponse?.firstName || ""}{" "}
              {aadhaarResponse?.middleName || ""} {aadhaarResponse?.lastName || ""}
            </p>
            <p className="text-gray-700 text-sm">
              <strong>ABHA number:</strong> {aadhaarResponse?.abhaNumber || "N/A"}
            </p>
            <p className="text-gray-700 text-sm">
              <strong>ABHA address:</strong> {aadhaarResponse?.preferredAbhaAddress || "N/A"}
            </p>
            <p className="text-gray-700 text-sm">
              <strong>Date of birth:</strong>{" "}
              {aadhaarResponse?.dob
                ? new Date(aadhaarResponse.dob).toISOString().split("T")[0]
                : "N/A"}
            </p>
            <p className="text-gray-700 text-sm">
              <strong>Gender:</strong>{" "}
              {aadhaarResponse?.gender
                ? aadhaarResponse.gender === "F"
                  ? "Female"
                  : aadhaarResponse.gender === "M"
                    ? "Male"
                    : aadhaarResponse.gender
                : "N/A"}

            </p>
            <p className="text-gray-700 text-sm">
              <strong>Mobile:</strong> {aadhaarResponse?.mobileNumber || "N/A"}
            </p>
            {/* <p className="text-gray-700 text-sm">
              <strong>Address:</strong> {aadhaarResponse?.address || "N/A"}
            </p> */}
          </div>

          {/* QR Code */}
          <div className="w-24 h-24 flex items-center justify-center border border-gray-300 bg-gray-100">
            {qrCode ? (
              <img src={qrCode} alt="QR Code" className="w-full h-full" />
            ) : (
              <span className="text-gray-400 text-sm">No QR</span>
            )}
          </div>
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        contentLabel="ABHA Card"
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          },
          content: {
            maxWidth: "600px",
            maxHeight: "55vh",
            margin: "auto",
            padding: "0",
            borderRadius: "10px",
            border: "none",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
            overflow: "hidden",
          },
        }}
      >

        <div className="flex items-center justify-between bg-teal-600 text-white px-4 py-3 rounded-t-lg">
          {/* Title */}
          <h2 className="text-lg font-semibold">ABHA Card</h2>

          {/* Buttons Group */}
          <div className="flex items-center gap-4">
            {/* Download Button */}
            <button
              onClick={downloadAbhaCard}
              className="text-white text-sm font-medium hover:text-gray-300 focus:outline-none"
            >
              Download
            </button>

            {/* Close Button */}
            <button
              onClick={() => setIsModalOpen(false)}
              className="text-white text-xl hover:text-gray-300 focus:outline-none"
            >
              ✕
            </button>
          </div>
        </div>


        {/* Body */}
        <div className="bg-white flex items-center justify-center p-4">
          {abhaCard ? (
            <img
              src={abhaCard}
              alt="ABHA Card"
              className="w-full max-h-[65vh] object-contain "
            />
          ) : (
            <p className="text-gray-500">ABHA card not available</p>
          )}
        </div>
      </Modal>


    </div>
  );
};

export default Profile;
